import { useFeatureFlag } from '~/composables/useFeatureFlag'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!useFeatureFlag('ssoLogin')) {
    return
  }

  const requiresAuth = to.meta.requiresAuth || false

  const userStore = useUserStore()
  const { readAccessToken } = useYscTokens()

  // Back from SSO with tokens, fetching regular user
  if (readAccessToken() && !userStore.isLoggedIn) {
    await userStore.fetchUser()
  }

  if (requiresAuth && !userStore.isLoggedIn) {
    // If the user navigates from another page of the app
    if (from.name) {
      userStore.openSSOModal()
      return abortNavigation()
    }
    // If the user tries to access the page directly (bookmark or external link)
    else {
      return navigateTo({ name: 'login' })
    }
  }
})
